import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Divider,
  Link,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FaDiscord, FaEnvelope } from "react-icons/fa";

function SupportContent() {
  const theme = useTheme();

  const paperStyles = {
    p: 4,
    backgroundColor: theme.palette.background.glass,
    backdropFilter: "blur(10px)",
    border: `1px solid ${theme.palette.border.light}`,
    borderRadius: 4,
  };

  return (
    <Container maxWidth="md" sx={{ py: 5, marginTop: "64px" }}>
      <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold", mb: 4 }}>
        Customer Support
      </Typography>

      {/* Contact Us Section */}
      <Paper elevation={0} sx={{ ...paperStyles, mb: 4 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 2 }}>
            For any questions, issues, or feedback, please reach out to us.
            We&apos;re here to help!
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 3, mb: 2 }}>
            <Link
              href="https://discord.gg/mspCBJp4E7"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: theme.palette.text.primary,
                textDecoration: "none",
                fontWeight: 500,
                "&:hover": { color: "#5865F2" },
              }}
            >
              <FaDiscord size={24} />
              Join our Discord
            </Link>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            <Link
              href="mailto:yw@mhome.ai"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: theme.palette.text.primary,
                textDecoration: "none",
                fontWeight: 500,
                "&:hover": { color: "#EA4335" },
              }}
            >
              <FaEnvelope size={24} />
              Email us at yw@mhome.ai
            </Link>
          </Box>
        </Box>
      </Paper>

      {/* Delete Account Section */}
      <Paper elevation={0} sx={paperStyles}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
            Delete Your Account
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 2 }}>
            You can permanently delete your mhome.ai account and all associated
            data. Please follow these steps carefully. This action is
            irreversible.
          </Typography>
          <Box
            component="ol"
            sx={{
              pl: 3,
              "& li": {
                mb: 1,
                lineHeight: 1.7,
              },
            }}
          >
            <li>
              Navigate to the mhome.ai application at{" "}
              <Link
                href="https://app.mhome.ai/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://app.mhome.ai/
              </Link>
              .
            </li>
            <li>Log in to your account if you haven&apos;t already.</li>
            <li>
              Go to the{" "}
              <Link
                href="https://app.mhome.ai/setting"
                target="_blank"
                rel="noopener noreferrer"
              >
                Setting
              </Link>{" "}
              Page.
            </li>
            <li>Find and click on the &quot;Delete Account&quot; button.</li>
            <li>
              You will be asked to confirm the deletion. Please read the
              confirmation message carefully before proceeding.
            </li>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}

export default SupportContent;
